import { Field, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

export const defaultLocation: DateRangeProps = {
  name: 'LOCATION HOURS NOT SET',
  active: true,
  fields: {
    dateRangeStart: { value: new Date(1, 0) },
    dateRangeEnd: { value: new Date(1, 0) },
    mondayOpen: { value: 'time not set' },
    mondayClose: { value: 'time not set' },
    tuesdayOpen: { value: 'time not set' },
    tuesdayClose: { value: 'time not set' },
    wednesdayOpen: { value: 'time not set' },
    wednesdayClose: { value: 'time not set' },
    thursdayOpen: { value: 'time not set' },
    thursdayClose: { value: 'time not set' },
    fridayOpen: { value: 'time not set' },
    fridayClose: { value: 'time not set' },
    saturdayOpen: { value: 'time not set' },
    saturdayClose: { value: 'time not set' },
    sundayOpen: { value: 'time not set' },
    sundayClose: { value: 'time not set' },
  },
};

export const emptyLocation: DateRangeProps = {
  name: '',
  active: false,
  fields: {
    dateRangeStart: { value: new Date(1, 0) },
    dateRangeEnd: { value: new Date(1, 0) },
    mondayOpen: { value: '' },
    mondayClose: { value: '' },
    tuesdayOpen: { value: '' },
    tuesdayClose: { value: '' },
    wednesdayOpen: { value: '' },
    wednesdayClose: { value: '' },
    thursdayOpen: { value: '' },
    thursdayClose: { value: '' },
    fridayOpen: { value: '' },
    fridayClose: { value: '' },
    saturdayOpen: { value: '' },
    saturdayClose: { value: '' },
    sundayOpen: { value: '' },
    sundayClose: { value: '' },
  },
};

export type DateRangeProps = {
  name: string;
  fields: DateRangeFields;
  active: boolean;
};

export type DateRangeFields = {
  dateRangeStart: Field<Date>;
  dateRangeEnd: Field<Date>;
  mondayOpen: Field<string>;
  mondayClose: Field<string>;
  tuesdayOpen: Field<string>;
  tuesdayClose: Field<string>;
  wednesdayOpen: Field<string>;
  wednesdayClose: Field<string>;
  thursdayOpen: Field<string>;
  thursdayClose: Field<string>;
  fridayOpen: Field<string>;
  fridayClose: Field<string>;
  saturdayOpen: Field<string>;
  saturdayClose: Field<string>;
  sundayOpen: Field<string>;
  sundayClose: Field<string>;
};

export type DateRangeObject = {
  label: string;
  open: string;
  close: string;
};

export type LocationProps = {
  fields: LocationFields;
  id: string;
};

export type LocationFields = {
  name: Field<string>;
  addressName: Field<string>;
  buildingName: Field<string>;
  postalBox: Field<string>;
  streetAddress1: Field<string>;
  streetAddress2: Field<string>;
  city: Field<string>;
  state: Field<string>;
  country: Field<string>;
  zip: Field<string>;
  latitude: Field<string>;
  longitude: Field<string>;
  directionsLabel: Field<string>;
  directionsLink: LinkField;
  phoneLabel: Field<string>;
  phoneLink: LinkField;
  tty: Field<string>;
  activeDateRanges: DateRangeProps[];
};
